const Vision = () => {
  return (
    <div id="OurVision" className="section dark">
      <div className="jumbotron">
        <h1 className="display-4">{"Our Vision & Mission"}</h1>
        <p className="lead">
          To make everyone the <i>meister</i> of their passion. To prepare as
          much people as we can reach around the changing world to the future
          with the advancement in technology and development in science.
        </p>
      </div>
    </div>
  );
};

export default Vision;
